import { createAsyncThunk } from "@reduxjs/toolkit";
import { getDashboardRevenueChart } from "../../api/ecommerce";

export const getRevenueChartsData = createAsyncThunk(
  "dashboardEcommerce/getRevenueChartsData",
  async (period = "all") => {
    const response = await getDashboardRevenueChart(period);
    return response;
  }
);
